<template>
  <AdminLayout>
    <Head title="Setup Two-Factor Credentials" />

    <template #sectionTitle> Setup </template>

    <template #pageTitle> Set Two-Factor Credentials </template>

    <div class="md:max-w-xl mx-auto">
      <form
        method="post"
        @submit.prevent="submit()"
      >
        <div class="sm:flex sm:items-center">
          <div class="input-group w-full">
            <input
              type="text"
              v-model="form.phone"
              name="phone"
              id="phone"
              placeholder="Enter a phone number"
            />
          </div>

          <button
            type="submit"
            :disabled="form.processing"
            class="btn btn-primary mt-3 sm:mt-0 sm:ml-3"
          >
            Set
          </button>
        </div>
        <p
          v-if="getErrors('phone')"
          class="input-error"
        >
          {{ getErrors('phone') }}
        </p>
      </form>
    </div>
  </AdminLayout>
</template>

<script>
import AdminLayout from '@/Layouts/AdminLight.vue'
import { Head, Link, usePage, useForm } from '@inertiajs/vue3'
import checksErrors from '@/Mixins/checksErrors'

export default {
  mixins: [checksErrors],

  components: {
    AdminLayout,
    Head,
    Link
  },

  data() {
    return {
      form: {
        phone: ''
      }
    }
  },

  created() {
    console.log('created()', this.errors)

    this.form = useForm(this.form)
  },

  methods: {
    submit() {
      this.form.post(route('user.setup.two-factor.store'), {
        onSuccess: () => {}
      })
    }
  }
}
</script>
